import { render, staticRenderFns } from "./TambahPerusahaan.vue?vue&type=template&id=76d74f86&scoped=true"
import script from "./TambahPerusahaan.vue?vue&type=script&lang=js"
export * from "./TambahPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./TambahPerusahaan.vue?vue&type=style&index=0&id=76d74f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d74f86",
  null
  
)

export default component.exports